import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../Navbar';
import { MdAddToPhotos } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';
import { FaCopyright } from "react-icons/fa";
import Menu_Items from '../Menu_Items';


function Conditionstable() {
  const { id, int_id, Ex_id } = useParams();
  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [monitor, setmonitor] = useState(false)
  const [alltables, setalltables] = useState([]);
  const [conditions, setconditions] = useState([{ 'and': [], 'or': [] }]);
  const [conditionsfields, setconditionsfields] = useState([]);
  const [conditiontablevalues, setconditiontablevalues] = useState([]);
  const [conditiontablenames, setconditiontablenames] = useState([]);
  const [linkedtable, setlinkedtable] = useState([]);
  const [addfield, setaddfield] = useState([]);
  const [conditiondivs, setConditiondivs] = useState([{ 'and': ['divand'], 'or': ['divor'] }]);
  const [search_Tables, setsearch_Tables] = useState('');

  let condition_tablename = [];
  let selectoperator = ['Equal to', 'Not Equal to'];
  const menus = [
    {
      name: 'Integrations',
      id,
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
      { name: 'Conditions', id, int_id, Ex_id },
      { name: 'Linked Tables', id, int_id, Ex_id },
      { name: 'Config', id, int_id, Ex_id },
      { name: 'Result', id, int_id, Ex_id },
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  // first Run
  const gettables = async () => {
    await axios.get(`/integ/tables/${int_id}`).then((res) => {
      let values = res.data;
      if (values === 'tables Not Fetched') {
        toast.error("tables Not Fetched", {
          autoClose: 2000, // 2 seconds
        });
      }
      else {
        setalltables(values);
      }

    })
      .catch((err) => {
        console.log("err :", err);
        toast.error("tables Not Fetched", {
          autoClose: 2000, // 2 seconds
        });
      });
    // get condition from db
    await axios.get(`/out_bound/export_value/${Ex_id}`).then((res) => {
      const response = res.data;
      if (response['Conditions']) {
        if (response['Conditions'] !== '') {
          let conditionval = JSON.parse(response['Conditions']);
          setconditions([conditionval]);
          let dbcon_val = [conditionval];
          let divand = [];
          let divor = [];
          if (dbcon_val[0]['and'].length !== 0) {
            dbcon_val[0]['and'].forEach(item => {
              divand.push('divand');
            });
          }
          else {
            divand.push('divand');
          }
          if (dbcon_val[0]['or'].length !== 0) {
            dbcon_val[0]['or'].forEach(item => {
              divor.push('divor');
            });
          }
          else {
            divor.push('divor');
          }
          setConditiondivs([{ 'and': divand, 'or': divor }]);
          setaddfield(['and', 'or']);
          dbcon_val[0]['and'].forEach(item => {
            condition_tablename.push(item['table']);
          });
          dbcon_val[0]['or'].forEach(item => {
            condition_tablename.push(item['table']);
          });
        }
      }
      if (response['Linked_Tables']) {
        if (response['Linked_Tables'] !== '') {
          let linkedtabledetail = JSON.parse(response['Linked_Tables']);
          setlinkedtable(linkedtabledetail);
          // linkedtabledetail.map((item) => {
          //   condition_tablename.push(item.mt);
          // });
          // let condition_tablenames = [...new Set(condition_tablename)];
          // condition_tablenames.map(item => {
          //   handleconditiontable(item, linkedtabledetail);
          // });
          if (response['Headers'] !== '') {
            const Headers = JSON.parse(response['Headers']);
            const data = Headers.map((obj) => Object.keys(obj)).flat()
            const tables = [...new Set(data)];
            tables.forEach((item) => {
              handleconditiontable(item, linkedtabledetail);
            })
          }
        };
      }
      else {
        // let condition_tablenames = [...new Set(condition_tablename)];
        // condition_tablenames.map(item => {
        //   handleconditiontable(item);
        // });
        if (response['Headers'] !== '') {
          const Headers = JSON.parse(response['Headers']);
          const data = Headers.map((obj) => Object.keys(obj)).flat()
          const tables = [...new Set(data)];
          tables.forEach((item) => {
            handleconditiontable(item);
          })
        }
        setlinkedtable(null);
      }
    })
      .catch((err) => {
        toast.error("Error From gettables", {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  // searcher by Tables
  const filterbyTables = alltables.filter(name =>
    name.toLowerCase().startsWith(search_Tables.toLowerCase())
  );
  // calls Required // response[0]['linkedtabledetails']
  const modifyAndArray = (objIndex, Index, Value = null, type) => {
    setconditions(prevState => {
      const updatedconditions = [...prevState];
      if (objIndex >= 0 && objIndex < updatedconditions.length) {
        const updatedArray = [...updatedconditions[objIndex][type]];
        if (Value === null && Index !== null && Index >= 0 && Index < updatedArray.length) {
          // Remove value at the specified index
          updatedArray.splice(Index, 1);
        } else if (Index !== null && Index >= 0 && Index < updatedArray.length) {
          // Update existing value
          updatedArray[Index] = Value;
        } else if (Value !== null) {
          // Add new value
          updatedArray.push(Value);
        }
        updatedconditions[objIndex] = {
          ...updatedconditions[objIndex],
          [type]: updatedArray
        };
      }
      return updatedconditions;
    });
    // if (type == 'and') {

    //   // setconditions(prevState => {
    //   //   const updatedconditions = [...prevState];
    //   //   if (objIndex >= 0 && objIndex < updatedconditions.length) {
    //   //     const updatedAndArray = [...updatedconditions[objIndex]['and']];
    //   //     if (Index !== null && Index >= 0 && Index < updatedAndArray.length) {
    //   //       // Update existing value
    //   //       updatedAndArray[Index] = Value;
    //   //     } else {
    //   //       // Add new value
    //   //       updatedAndArray.push(Value);
    //   //     }
    //   //     updatedconditions[objIndex] = {
    //   //       ...updatedconditions[objIndex],
    //   //       'and': updatedAndArray
    //   //     };
    //   //   }
    //   //   return updatedconditions;
    //   // });
    // }
    // else{
    //   // setconditions(prevState => {
    //   //   const updatedconditions = [...prevState];
    //   //   if (objIndex >= 0 && objIndex < updatedconditions.length) {
    //   //     const updatedOrArray = [...updatedconditions[objIndex]['or']];
    //   //     if (Index !== null && Index >= 0 && Index < updatedOrArray.length) {
    //   //       // Update existing value
    //   //       updatedOrArray[Index] = Value;
    //   //     } else {
    //   //       // Add new value
    //   //       updatedOrArray.push(Value);
    //   //     }
    //   //     updatedconditions[objIndex] = {
    //   //       ...updatedconditions[objIndex],
    //   //       'or': updatedOrArray
    //   //     };
    //   //   }
    //   //   return updatedconditions;
    //   // });
    // }

  };
  const handleconditiontable = async (name, linkedtabledetail = null) => {
    if (conditiontablenames.includes(name)) {
      setconditionsfields(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
      setconditiontablevalues(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
      setconditiontablenames(conditiontablenames.filter(item => item !== name));
    }
    else {
      setconditiontablenames(prevState => [...prevState, name]);
      await axios.get(`/integ/field/${name}/${int_id}`).then((res) => {
        let values = res.data;
        setconditionsfields(prevState => [...prevState, { [name]: values }]);
        // setconditionsfields([...conditionsfields, { [name]: values }]);
      })
        .catch((err) => {
          console.log("Error from conditiontables.js ");
        });
      await axios.get(`/integ/field/values/${name}/${int_id}`).then(async (res) => {
        let values = res.data;
        if (linkedtabledetail) {
          await handlelinkedtables(name, values, linkedtabledetail);
        }
        else {
          setconditiontablevalues(prevState => [...prevState, { [name]: values }]);
        }
      })
        .catch((err) => {
          console.log("Error From Tables Page line no : 295 ");
        });

    };

  };
  const addDiv = async (type) => {
    if (addfield.includes(type)) {
      if (type === 'and') {
        setConditiondivs(prevConditiondivs =>
          prevConditiondivs.map((condition, index) => {
            if (index === 0) {
              return {
                ...condition,
                and: [...condition.and, 'divadd']
              };
            }
            return condition;
          })
        );
        setaddfield((prevData => prevData.filter((item) => item !== type)));
      }
      else {
        setConditiondivs(prevConditiondivs =>
          prevConditiondivs.map((condition, index) => {
            if (index === 0) {
              return {
                ...condition,
                or: [...condition.or, 'divadd']
              };
            }
            return condition;
          })
        );
        setaddfield((prevData => prevData.filter((item) => item !== type)));
      }
    }
  };
  const closediv = (type, index) => {
    modifyAndArray(0, index, null, type);
    if (index !== 0) {
      setConditiondivs(prevConditiondivs =>
        prevConditiondivs.map((condition, index) => {
          if (index === 0) {
            return {
              ...condition,
              [type]: condition[type].slice(0, -1)
            };
          }
          return condition;
        })
      );
    }
    let divlength = conditiondivs[0][type].length;
    if (divlength === index + 1) {
      setaddfield([...addfield, type]);
    }
  };
  const handleconditionfield = async (e, i, type) => {
    setaddfield([...addfield, type]);
    const value = e.target.value;
    const [item, tname] = value.split(' --- ');
    let t = tname;
    let v = item;
    modifyAndArray(0, i, { 'table': t, 'field': v }, type);
  };

  const updatebyCondition = (type, index, field, value) => {
    setconditions(prevConditions => {
      return prevConditions.map(condition => ({
        ...condition,
        [type]: condition[type].map((item, i) => {
          if (i === index) {
            return { ...item, [field]: value };
          }
          return item;
        })
      }));
    });
  };
  const filterByField = (arr, field) => {
    const seenValues = new Set();

    try {
      return arr.filter(item => {
        if (!seenValues.has(item[field])) {
          seenValues.add(item[field]);
          return true;
        }
        return false;
      });
    }
    catch {
      return false;
    }
  };
  const handlelinkedtables = async (name, value, linkedTableDetail) => {
    let old_values = value; // Start with the initial value array
    for (const obj of linkedTableDetail) {
      if (obj.mt === name) {
        try {
          const res = await axios.post(`/integ/checklinked/${int_id}`, obj);
          const values = res.data;
          old_values = old_values.map(item => {
            let new_values = values.find(val => val[obj.ltf] === item[obj.mtf]);


            return { ...item, [obj.mtf]: new_values ? new_values[obj.mtf] : item[obj.mtf] };
          });
        } catch (err) {
          console.log('Error from test:', err);
        }
      }
    };
    // Update the state with the final array
    setconditiontablevalues(prevState => [...prevState, { [name]: old_values }]);
  };
  const conditionsubmit = async () => {
    let value = JSON.stringify(conditions[0]);
    let conditionValue = {
      Conditions: value
    };
    await axios.patch(`/out_bound/Conditions/${Ex_id}`, conditionValue).then((res) => {
      toast.success("Condition Updated", {
        autoClose: 2000, // 2 seconds
      });
    })
      .catch((err) => {
        console.log('Conditiontable api error');
      });
    // setisopen(!isopen)
  };
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else {
      setmonitor(true)
    }

  };
  useEffect(() => {
    gettables();
    get_level();
  }, []);

  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <FaCopyright className='page_icon db' />
              <p>Conditions</p>
            </div>
          </div>
          <div className='box df jc ac'>
            {/* <div className='h83 w15'>
              <div className='condition_table_box_head df jc ac'>
                <p>Tables</p>
              </div>
              <div className='condition_table_box_content_tablessearch df jc ac b0100'>
                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                <input type='search' id='ser_table' placeholder='Search' onChange={e => setsearch_Tables(e.target.value)} />
              </div>
              <div className='condition_table_box_content b0100'>
                {
                  filterbyTables.length > 0 && filterbyTables.map((val, index) => {
                    let table = val.charAt(0).toUpperCase() + val.slice(1);
                    return (
                      <div className=' condition_table_box_content_con df gap ac m1' key={index}>
                        <input type='checkbox' onChange={() => { handleconditiontable(val, linkedtable) }} id={index} checked={conditiontablenames.includes(val)} disabled={monitor} />
                        <label htmlFor={index} >{table}</label>
                      </div>
                    )
                  })
                }
              </div>
            </div> */}
            <div className='h83 w100'>
              {/* <div className='condition_table_box2_head df jc ac'>
                <p>Conditions</p>
              </div> */}
              <div className='condition_table_box2_Content df fdc ac'>
                <div className='condition_model_add df jb ac'>
                  <div></div>
                  <div className='addicondiv df je ac'>
                    {!monitor &&
                      <MdAddToPhotos onClick={() => { addDiv('and'); }} className='icon3 g' />
                    }
                  </div>
                </div>
                {
                  conditiondivs[0]['and'].map((div, index) => {
                    let divlength = conditiondivs[0]['and'].length;
                    return (
                      <div className="condition_model_select df js" key={`div-and-${index}`}>
                        <div className="df jc">
                          {divlength === 1 && (
                            <div className="dashfirst df jc ac">
                              <p className="df jc ac">AND</p>
                            </div>
                          )}
                          {index + 1 < divlength && (
                            <div className="dash df jc ac">
                              <p className="df jc ac">AND</p>
                            </div>
                          )}
                          {index + 1 === divlength && <div className="dashlast" />}
                          <div className="condition_field_div df fdc jc">
                            <label>Select Fields</label>
                            <select
                              className="df jc ac"
                              value={
                                conditions[0]['and'][index]?.field
                                  ? `${conditions[0]['and'][index].field} --- ${conditions[0]['and'][index].table}`
                                  : ""
                              }
                              onChange={(e) => {
                                handleconditionfield(e, index, 'and');
                              }} disabled={monitor}
                            >
                              <option value="">Please Select</option>
                              {conditionsfields.map((obj, objIndex) => {
                                const tna = Object.keys(obj)[0];
                                return obj[tna].map((ite, iteIndex) => {
                                  const tname = tna.charAt(0).toUpperCase() + tna.slice(1);
                                  const item = ite.charAt(0).toUpperCase() + ite.slice(1);
                                  return (
                                    <option key={`field-${objIndex}-${iteIndex}`} value={`${ite} --- ${tna}`}>
                                      {item} - {tname}
                                    </option>
                                  );
                                });
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="m1 df fdc jc">
                          <label>Select Operator</label>
                          <select
                            value={conditions[0]['and'][index]?.operator || ""}
                            onChange={(e) => updatebyCondition('and', index, 'operator', e.target.value)} disabled={monitor}
                          >
                            <option value="">Please Select</option>
                            {selectoperator.map((op, opIndex) => {
                              const value = op === 'Equal to' ? '=' : '!=';
                              return (
                                <option key={`operator-${opIndex}`} value={value}>
                                  {op}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="m1 df fdc jc">
                          <label>Select Value</label>
                          <select
                            value={conditions[0]['and'][index]?.value || ""}
                            onChange={(e) => updatebyCondition('and', index, 'value', e.target.value)} disabled={monitor}
                          >
                            <option value="">Please Select</option>
                            {conditiontablevalues.map((obj, objIndex) => {
                              const tname = conditions[0]['and'][index]?.table;
                              const field = conditions[0]['and'][index]?.field;
                              if (obj[tname]) {
                                return filterByField(obj[tname], field).map((item, itemIndex) => {
                                  const val = item[field];
                                  const displayValue =
                                    val === ""
                                      ? "Empty"
                                      : val === null
                                        ? "Null"
                                        : val === undefined
                                          ? "Undefined"
                                          : typeof val === "string" ? val.charAt(0).toUpperCase() + val.slice(1) : val;
                                  return (
                                    <option key={`value-${objIndex}-${itemIndex}`} value={val}>
                                      {displayValue}
                                    </option>
                                  );
                                });
                              }
                            })}
                          </select>
                        </div>
                        <div className="condition_field_close df jc ac">
                          {!monitor && <IoClose className="r" onClick={() => closediv('and', index)} />}
                        </div>
                      </div>
                    );
                  })
                }
                <div className='condition_model_add df jb ac'>
                  <div></div>
                  <p className='df jc ac'>AND</p>
                  <div className='addicondiv df je ac'>
                    {!monitor &&
                      // OR Conditions
                      <MdAddToPhotos className='icon3 g' onClick={() => { addDiv('or'); }} />
                    }
                  </div>
                </div>
                {
                  conditiondivs[0]['or'].map((div, index) => {
                    let divlength = conditiondivs[0]['or'].length;
                    return (
                      <div className='condition_model_select df js' key={`or-${index}`}>
                        <div className='df jc'>
                          {index + 1 < divlength && (
                            <div className='dash df jc ac'>
                              <p className='df jc ac'>OR</p>
                            </div>
                          )}
                          {index + 1 === divlength && <div className='dashlast'></div>}
                          {divlength === 1 && (
                            <div className='dashfirst df jc ac'>
                              <p className='df jc ac'>OR</p>
                            </div>
                          )}
                          <div className='condition_field_div df fdc jc'>
                            <label>Select Fields</label>
                            <select
                              className='df jc ac'
                              value={
                                conditions[0]['or'][index]?.field
                                  ? `${conditions[0]['or'][index].field} --- ${conditions[0]['or'][index].table}`
                                  : ""
                              }
                              onChange={(e) => handleconditionfield(e, index, 'or')} disabled={monitor}
                            >
                              <option value="">Please Select</option>
                              {conditionsfields.map((obj) => {
                                let tna = Object.keys(obj);
                                let tnam = tna[0];
                                return (
                                  obj[tnam].length > 0 &&
                                  obj[tnam].map((ite) => {
                                    let tname = tnam.charAt(0).toUpperCase() + tnam.slice(1) || tnam;
                                    let item = ite.charAt(0).toUpperCase() + ite.slice(1) || ite;
                                    return (
                                      <option key={`${tnam}-${ite}`} value={`${ite} --- ${tnam}`}>
                                        {item} - {tname}
                                      </option>
                                    );
                                  })
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className='m1 df fdc jc'>
                          <label>Select Operator</label>
                          <select
                            value={conditions[0]['or'][index]?.operator || ""}
                            onChange={(e) => updatebyCondition('or', index, 'operator', e.target.value)} disabled={monitor}
                          >
                            <option value="">Please Select</option>
                            {selectoperator.map((op) => {
                              const value = op === 'Equal to' ? '=' : '!=';
                              return (
                                <option key={`operator-${op}`} value={value}>
                                  {op}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className='m1 df fdc jc'>
                          <label>Select value</label>
                          <select
                            value={conditions[0]['or'][index]?.value || ""}
                            onChange={(e) => updatebyCondition('or', index, 'value', e.target.value)} disabled={monitor}
                          >
                            <option value="">Please Select</option>
                            {conditiontablevalues.map((obj) => {
                              let tname = conditions[0]['or'][index]?.table;
                              let field = conditions[0]['or'][index]?.field;
                              if (obj[tname]) {
                                return filterByField(obj[tname], field).map((item, i) => {
                                  let val = item[field];
                                  const displayValue =
                                    val === ""
                                      ? "Empty"
                                      : val === null
                                        ? "Null"
                                        : val === undefined
                                          ? "Undefined"
                                          : typeof val === "string" ? val.charAt(0).toUpperCase() + val.slice(1) : val;
                                  return (
                                    <option key={`value-${i}-${val}`} value={val}>
                                      {displayValue}
                                    </option>
                                  );
                                });
                              }
                            })}
                          </select>
                        </div>
                        <div className='condition_field_close df jc ac'>
                          {!monitor && <IoClose className='r' onClick={() => closediv('or', index)} />}

                        </div>
                      </div>
                    );
                  })
                }

              </div>
              <div className='condition_table_box2_action df jc ac'>
                {
                  !monitor && <button className='btn green' onClick={conditionsubmit}>Submit</button>
                }

              </div>
            </div>
          </div>
        </div>
      </div>

    </div >
  )
}

export default Conditionstable;